import React, { useState, useMemo, useRef, useEffect } from "react";
const UPDATE_COLOR = "rgb(173, 228, 234)";

const DescriptionRender = (props, ref) => {
    // const { webContent, tableD } = props;
    const descRef = useRef(null);

    const render = useMemo(() => {
        let check = props?.data?.compare;
        if (check) {
            check = check.webContent;
        } else {
            check = props?.data?.master.webContent;
        }
        return <div className={"ck-content ck-readnonly"} dangerouslySetInnerHTML={{ __html: check }}></div>;
    }, [props]);

    useEffect(() => {
        if (props.data.compare) {
            const figcaptionDiff = props?.data?.compare.figcaptionDiff;

            if (figcaptionDiff) {
                Object.keys(figcaptionDiff)?.forEach((e) => {
                    const text = figcaptionDiff[e];
                    const element = descRef.current?.querySelector(`*[data-uniquecode="${e}"]`);
                    if(element) {
                        element.querySelectorAll("p.diff")?.forEach((e) => {
                            e.remove()
                        });
                        element.style.backgroundColor = UPDATE_COLOR;
                        element.innerHTML = `<p class="diff" style="color: #AAA; text-decoration: line-through">${text}</p>${element.innerHTML}`;
                    }
                });
            }

            const tdthUpdate = props?.data?.compare.tdthUpdate;
            if (tdthUpdate) {
                Object.keys(tdthUpdate)?.forEach((e) => {
                    const text = tdthUpdate[e];

                    const element = descRef.current?.querySelector(`*[data-uniquecode="${e}"]`);
                    if(element) {
                        element?.querySelectorAll("p.diff")?.forEach((e) => {
                            e.remove()
                        });
                        element.style.backgroundColor = UPDATE_COLOR
                        element.innerHTML = `<p class="diff" style="color: #AAA; text-decoration: line-through">${text}</p>${element.innerHTML}`;
                    }
                });
            }
        }
    }, [props]);

    return (
        <div className={"description-page"} ref={descRef}>
            {render}
        </div>
    );
};

export default DescriptionRender;
